import { formatNumberValue } from '@eureka/utils/number-format';
import type { ISolution, ISolutionListResponse } from '@eureka/solution-card/src/types';

export abstract class ListBaseService {
  protected abstract fetchData(data: {
    page: number;
    limit: number;
    data?: Record<string, unknown>;
  }): Promise<ISolutionListResponse>;

  public list: ISolution[] = [];
  public loading = false;
  public moreLoading = false;
  public total = '0';

  private page = 1;
  public hasNext = false;

  private scrollRefElement: HTMLElement| undefined

  constructor(scrollRefElement?: HTMLElement) {
      this.scrollRefElement = scrollRefElement;
  }

  public get isEmpty() {
      return this.list.length === 0;
  }

  public async loadInitialData(fetchRequestData: Record<string, unknown> = {}) {
      this.loading = true;
      try {
          const res = await this.fetchData({
              ...fetchRequestData,
              page: this.page,
              limit: 20,
          });
          this.list = res.records;
          this.total = formatNumberValue(res.total);
          this.hasNext = res.has_next;
      } finally {
          this.loading = false;
      }
  }

  /**
   * 滚动加载更多
   */
  public async loadMore(fetchRequestData: Record<string, unknown> = {}) {
      this.moreLoading = true;
      this.page += 1;
      try {
          const res = await this.fetchData({
              ...fetchRequestData,
              page: this.page,
              limit: 20,
          });
          this.list.push(...res.records);
          this.hasNext = res.has_next;
      } finally {
          this.moreLoading = false;
      }
  }

  /**
   * 当滚动到底部时触发加载更多数据
   */
  public handleScroll(fetchRequestData: Record<string, unknown> = {}) {
      const scrollContainerEle = this.scrollRefElement;
      if (!this.hasNext || this.moreLoading || !scrollContainerEle) return;
      if (
          scrollContainerEle.scrollTop + scrollContainerEle.clientHeight >=
      scrollContainerEle.scrollHeight
      ) {
          this.loadMore(fetchRequestData);
      }
  }
}
